import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

// Drop-in replacement for next/link's default export.
// next/link accepts `href`; react-router-dom's Link accepts `to`.
// We translate `href` to `to` and ignore Next-only props (prefetch, scroll, etc).
export const RouterLink = forwardRef(function RouterLink(
  { href, to, prefetch, scroll, replace, shallow, locale, passHref, legacyBehavior, ...other },
  ref
) {
  return <Link ref={ref} to={to ?? href ?? '#'} replace={replace} {...other} />;
});

export default RouterLink;
